import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeURL } from '../services/Webservice';
import './Login.css';
import logo from '../assets/Crlogo.webp';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        // Basic validation
        if (!email || !password) {
            setError('Please enter both email and password');
            setIsLoading(false);
            return;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError('Please enter a valid email address');
            setIsLoading(false);
            return;
        }

        try {
            // Create FormData for API request
            const formdata = new FormData();
            formdata.append("UserName", email);
            formdata.append("Password", password);

            const requestOptions = {
                method: "POST",
                body: formdata,
                redirect: "follow"
            };

            // Call the login API
            const response = await fetch(`${HomeURL}api/Values/Login`, requestOptions);
            const result = await response.text();

            // Parse the response
            const userData = JSON.parse(result);

            // Check if login was successful (API returns array with user data)
            if (Array.isArray(userData) && userData.length > 0) {
                const user = userData[0];

                // Store authentication data
                localStorage.setItem('isAuthenticated', 'true');
                localStorage.setItem('userEmail', user.EMAIL);
                localStorage.setItem('userName', user.EMP_NAME);
                localStorage.setItem('userId', user.EMP_ID);
                localStorage.setItem('userRole', user.ROLEID);
                localStorage.setItem('userData', JSON.stringify(user));

                setIsLoading(false);
                navigate('/dashboard');
            } else {
                // Login failed - invalid credentials
                setError('Invalid email or password. Please try again.');
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Login error:', error);
            setError('Unable to connect to server. Please check if the API is running.');
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
            </div>

            <div className="login-card">
                <div className="login-header">
                    <div className="login-logo">
                        <img src={logo} alt="Credence Diagnostics Logo" className="logo-image" />
                    </div>
                    <h1>Welcome Back</h1>
                    <p>Sign in to Credence Admin Portal</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    {error && (
                        <div className="error-message">
                            <span className="error-icon">⚠️</span>
                            {error}
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <div className="input-wrapper">
                            <span className="input-icon">📧</span>
                            <input
                                type="email"
                                id="email"
                                placeholder="admin@credence.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div className="input-wrapper">
                            <span className="input-icon">🔒</span>
                            <input
                                type="password"
                                id="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                    </div>

                    <div className="form-options">
                        <label className="remember-me">
                            <input type="checkbox" />
                            <span>Remember me</span>
                        </label>
                        <a href="#" className="forgot-password">Forgot password?</a>
                    </div>

                    <button
                        type="submit"
                        className="login-button"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner"></span>
                                Signing in...
                            </>
                        ) : (
                            'Sign In'
                        )}
                    </button>
                </form>

                <div className="login-footer">
                    <p>© 2026 Credence Diagnostics. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
}

export default Login;
